import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import 'filepond/dist/filepond.min.css'

import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size'
import { forwardRef } from 'react'
import { FilePond, registerPlugin } from 'react-filepond'
import { maxFileSizeBytes as defaultMaxFileSizeBytes, matchesAcceptedFileType } from 'features/Messaging/fileUploadConfig'
import config from 'services/config'
import { getDirectfulUploadHeaders } from 'services/helpers/responseHandler'
import LocalUserService from 'services/localUserService'

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImageValidateSize
)

const userService = new LocalUserService()

const DragAndDropUploader = forwardRef(
  (
    {
      baseUrl = config.apiUrl,
      url,
      headers = {},
      onData,
      onLoad,
      onError,
      labelIdle = '',
      labelFileProcessingError = 'Something went wrong',
      acceptedFileTypes = [],
      maxFileSize = null,
      maxFileSizeBytes = null,
      onFileSizeExceeded,
      onInvalidFileType,
      onUpdateFiles,
      maxFiles = 10,
      allowImageValidateSize = false,
      imageValidateSizeMinWidth = 0,
      imageValidateSizeMinHeight = 0,
      disabled = false,
      serverProcess = null
    },
    ref
  ) => {
    const serverConfig = serverProcess
      ? {
          revert: null,
          process: serverProcess
        }
      : {
          url: baseUrl,
          revert: null,
          process: {
            url,
            method: 'POST',
            headers: (file, metadata) => getDirectfulUploadHeaders(url, headers),
            ondata: onData,
            onload: onLoad,
            onerror: onError
          }
        }

    return (
      <FilePond
        ref={ref}
        key={userService.getCurrentUserInfo()?.sessionId}
        disabled={disabled}
        dropOnPage={true}
        dropOnElement={false}
        allowPaste={true}
        labelIdle={labelIdle}
        labelFileProcessingError={labelFileProcessingError}
        allowMultiple={false}
        maxFiles={maxFiles}
        maxFilesmaxParallelUploads={1}
        imageValidateSizeMinWidth={imageValidateSizeMinWidth}
        imageValidateSizeMinHeight={imageValidateSizeMinHeight}
        allowImageValidateSize={allowImageValidateSize}
        imagePreviewMinHeight={100}
        name="file"
        minFileSize={0}
        onupdatefiles={onUpdateFiles}
        beforeAddFile={fileItem => {
          const fileType = fileItem.fileType || fileItem.file?.type

          if (
            onInvalidFileType &&
            acceptedFileTypes?.length &&
            fileType &&
            !matchesAcceptedFileType(fileType, acceptedFileTypes)
          ) {
            onInvalidFileType()
            return false
          }

          if (!onFileSizeExceeded) {
            return true
          }

          const limitBytes = maxFileSizeBytes ?? defaultMaxFileSizeBytes
          if (fileItem.fileSize <= limitBytes) {
            return true
          }

          onFileSizeExceeded()
          return false
        }}
        acceptedFileTypes={acceptedFileTypes}
        maxFileSize={maxFileSize}
        server={serverConfig}
      />
    )
  }
)

export default DragAndDropUploader
